import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import './CookieBanner.css';

const CookieBanner = ({ appName }) => {
    return (
        <CookieConsent
            location="bottom"
            cookieName="cookieConsent"
            expires={150}
            style={{ background: "transparent", border: "none", boxShadow: "none" }} // Reset default styles
            buttonStyle={{}} // Use classes for styling
            declineButtonStyle={{ display: "none" }} // Use classes for styling
            contentStyle={{
                margin: "0",
                flex: "1 0 auto"
            }}
            buttonText="Accept"
            enableDeclineButton
            declineButtonText="Decline"
            flipButtons
            containerClasses="viblica-cookie-consent-container"
            contentClasses="viblica-cookie-consent-content"
            buttonClasses="viblica-cookie-accept-btn"
            declineButtonClasses="viblica-cookie-decline-btn"
            overlay={false}
        >
            <div className="viblica-cookie-card">
                <div className="viblica-cookie-header">
                    <div className="viblica-cookie-icon-bg">
                        <Cookie size={20} className="text-blue-600" />
                    </div>
                    <h4 className="viblica-cookie-title">Cookie Policy</h4>
                </div>

                <p className="viblica-cookie-text">
                    We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept", you consent to our use of cookies.
                    <span className="viblica-cookie-links">
                        <Link to="/privacy" className="viblica-cookie-link">Privacy Policy</Link>
                        <span className="viblica-separator">•</span>
                        <Link to="/terms" className="viblica-cookie-link">Terms of Service</Link>
                    </span>
                </p>
            </div>
        </CookieConsent>
    );
};

export default CookieBanner;
